import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import * as actionCreators from '../redux/actions/actionCreators';

function mapStateToProps(state) {
  return {
    isAuthenticated: state.authenticate.isAuthenticated,
    serverMaintenance: state.appState.serverMaintenance
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

function BoundPrivateRoute({
  redirectPath = '/signin',
  portalMerchant = false,
  isAuthenticated = false,
  serverMaintenance = false
}) {
  const location = useLocation();
  let Component = Navigate; // = (isAuthenticated && (portalMerchant && location.pathname.includes('/application'))) ? <Navigate /> : <Outlet />
  let targetPath = redirectPath; // = (isAuthenticated && portalMerchant && location.pathname.includes('/application')) ? "/dashboard" : redirectPath;
  let replace = true;
  let exact = false;
  let state = true;

  if (serverMaintenance) {
    targetPath = '/serverMaintenance';
    state = false;
    replace = true;
  }

  if (!serverMaintenance && isAuthenticated) {
    // basic check, will only be passed in PORTAL, and if the user is a merchant
    state = false;
    if (
      portalMerchant &&
      (location.pathname.includes('/application') || location.pathname.includes('/application-v2'))
    ) {
      // prevent merchants from accessing /application
      exact = true;
      replace = false;
      targetPath = '/dashboard';
    } else {
      targetPath = null;
      Component = Outlet;
    }
  }

  return (
    <Component
      {...(targetPath && { to: targetPath })}
      {...(state && { state: { from: location } })}
      {...(replace && { replace })}
      {...(exact && { exact })}
    />
  );
}

BoundPrivateRoute.propTypes = {
  redirectPath: PropTypes.string,
  portalMerchant: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  serverMaintenance: PropTypes.bool
};

const PrivateRoute = connect(mapStateToProps, mapDispatchToProps)(BoundPrivateRoute);

export default PrivateRoute;
